/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ColumnExport } from './ColumnExport';
import {
    ColumnExportFromJSON,
    ColumnExportFromJSONTyped,
    ColumnExportToJSON,
} from './ColumnExport';
import type { ColumnSettings } from './ColumnSettings';
import {
    ColumnSettingsFromJSON,
    ColumnSettingsFromJSONTyped,
    ColumnSettingsToJSON,
} from './ColumnSettings';
import type { ColumnVisibilitySettings } from './ColumnVisibilitySettings';
import {
    ColumnVisibilitySettingsFromJSON,
    ColumnVisibilitySettingsFromJSONTyped,
    ColumnVisibilitySettingsToJSON,
} from './ColumnVisibilitySettings';
import type { Paging } from './Paging';
import {
    PagingFromJSON,
    PagingFromJSONTyped,
    PagingToJSON,
} from './Paging';
import type { RowSelectionSettings } from './RowSelectionSettings';
import {
    RowSelectionSettingsFromJSON,
    RowSelectionSettingsFromJSONTyped,
    RowSelectionSettingsToJSON,
} from './RowSelectionSettings';
import type { RowStateInfo } from './RowStateInfo';
import {
    RowStateInfoFromJSON,
    RowStateInfoFromJSONTyped,
    RowStateInfoToJSON,
} from './RowStateInfo';
import type { Sorting } from './Sorting';
import {
    SortingFromJSON,
    SortingFromJSONTyped,
    SortingToJSON,
} from './Sorting';
import type { StaleState } from './StaleState';
import {
    StaleStateFromJSON,
    StaleStateFromJSONTyped,
    StaleStateToJSON,
} from './StaleState';
import type { TableFilterSettings } from './TableFilterSettings';
import {
    TableFilterSettingsFromJSON,
    TableFilterSettingsFromJSONTyped,
    TableFilterSettingsToJSON,
} from './TableFilterSettings';
import type { Units } from './Units';
import {
    UnitsFromJSON,
    UnitsFromJSONTyped,
    UnitsToJSON,
} from './Units';

/**
 * 
 * @export
 * @interface RowState
 */
export interface RowState {
    /**
     * 
     * @type {ColumnSettings}
     * @memberof RowState
     */
    columnSettings?: ColumnSettings;
    /**
     * 
     * @type {ColumnExport}
     * @memberof RowState
     */
    columnExport?: ColumnExport;
    /**
     * 
     * @type {ColumnVisibilitySettings}
     * @memberof RowState
     */
    columnVisibilitySettings?: ColumnVisibilitySettings;
    /**
     * 
     * @type {TableFilterSettings}
     * @memberof RowState
     */
    filtering?: TableFilterSettings;
    /**
     * 
     * @type {Paging}
     * @memberof RowState
     */
    paging?: Paging;
    /**
     * 
     * @type {RowSelectionSettings}
     * @memberof RowState
     */
    rowSelectionSettings?: RowSelectionSettings;
    /**
     * 
     * @type {RowStateInfo}
     * @memberof RowState
     */
    rowStateInfo?: RowStateInfo;
    /**
     * 
     * @type {Sorting}
     * @memberof RowState
     */
    sorting?: Sorting;
    /**
     * 
     * @type {StaleState}
     * @memberof RowState
     */
    staleState?: StaleState;
    /**
     * 
     * @type {Units}
     * @memberof RowState
     */
    units?: Units;
    /**
     * 
     * @type {boolean}
     * @memberof RowState
     */
    onlyCounting?: boolean;
}

/**
 * Check if a given object implements the RowState interface.
 */
export function instanceOfRowState(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RowStateFromJSON(json: any): RowState {
    return RowStateFromJSONTyped(json, false);
}

export function RowStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): RowState {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'columnSettings': !exists(json, 'columnSettings') ? undefined : ColumnSettingsFromJSON(json['columnSettings']),
        'columnExport': !exists(json, 'columnExport') ? undefined : ColumnExportFromJSON(json['columnExport']),
        'columnVisibilitySettings': !exists(json, 'columnVisibilitySettings') ? undefined : ColumnVisibilitySettingsFromJSON(json['columnVisibilitySettings']),
        'filtering': !exists(json, 'filtering') ? undefined : TableFilterSettingsFromJSON(json['filtering']),
        'paging': !exists(json, 'paging') ? undefined : PagingFromJSON(json['paging']),
        'rowSelectionSettings': !exists(json, 'rowSelectionSettings') ? undefined : RowSelectionSettingsFromJSON(json['rowSelectionSettings']),
        'rowStateInfo': !exists(json, 'rowStateInfo') ? undefined : RowStateInfoFromJSON(json['rowStateInfo']),
        'sorting': !exists(json, 'sorting') ? undefined : SortingFromJSON(json['sorting']),
        'staleState': !exists(json, 'staleState') ? undefined : StaleStateFromJSON(json['staleState']),
        'units': !exists(json, 'units') ? undefined : UnitsFromJSON(json['units']),
        'onlyCounting': !exists(json, 'onlyCounting') ? undefined : json['onlyCounting'],
    };
}

export function RowStateToJSON(value?: RowState | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'columnSettings': ColumnSettingsToJSON(value.columnSettings),
        'columnExport': ColumnExportToJSON(value.columnExport),
        'columnVisibilitySettings': ColumnVisibilitySettingsToJSON(value.columnVisibilitySettings),
        'filtering': TableFilterSettingsToJSON(value.filtering),
        'paging': PagingToJSON(value.paging),
        'rowSelectionSettings': RowSelectionSettingsToJSON(value.rowSelectionSettings),
        'rowStateInfo': RowStateInfoToJSON(value.rowStateInfo),
        'sorting': SortingToJSON(value.sorting),
        'staleState': StaleStateToJSON(value.staleState),
        'units': UnitsToJSON(value.units),
        'onlyCounting': value.onlyCounting,
    };
}

